import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { adminLogout } from '../config/api';

const NAV = [
  { label: 'Dashboard',       path: '/admin/dashboard'       },
  { label: 'Photo Gallery',   path: '/admin/photo-gallery'   },
  { label: 'Organize Photos', path: '/admin/photos'          },
  { label: 'Categories',      path: '/admin/categories'      },
  { label: 'Inquiries',       path: '/admin/inquiries'       },
  { label: 'About Page',      path: '/admin/about'           },
  { label: 'Home Page',       path: '/', external: true      },
];

export default function AdminLayout({ children, title }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleLogout = async () => {
    try { await adminLogout(); } catch (e) {}
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  return (
    <>
      {/* Hamburger Menu Button */}
      <button
        className="admin-hamburger"
        onClick={() => setMenuOpen(true)}
        aria-label="Open menu"
      >
        <Menu size={24} color="var(--color-text)" />
      </button>

      <div className="admin-layout" style={{ display: 'grid', gridTemplateColumns: '200px 1fr', minHeight: '100vh' }}>

        <aside className={`admin-sidebar ${menuOpen ? 'menu-open' : ''}`} style={{ background: 'var(--color-dark-bg)', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '22px 16px 18px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <span style={{ fontFamily: 'var(--font-display)', fontSize: 20, color: '#fff', fontWeight: 400 }}>
              📷 Admin
            </span>
          </div>

          <nav style={{ flex: 1, paddingTop: 8 }}>
            {NAV.map(item => {
              const active = !item.external && (
                location.pathname === item.path ||
                (item.path === '/admin/photo-gallery' && location.pathname.startsWith('/admin/photo-gallery'))
              );
              return (
                <button
                  key={item.path}
                  onClick={() => {
                    if (item.external) {
                      window.open(item.path, '_blank');
                      setMenuOpen(false);
                    } else {
                      navigate(item.path);
                    }
                  }}
                  style={{
                    width: '100%',
                    textAlign: 'left',
                    background: 'none',
                    border: 'none',
                    borderLeft: active ? '3px solid var(--color-accent)' : '3px solid transparent',
                    padding: active ? '12px 13px' : '12px 16px',
                    fontSize: 12,
                    fontFamily: 'var(--font-body)',
                    cursor: 'pointer',
                    color: active ? 'var(--color-accent)' : '#777',
                    letterSpacing: '0.04em',
                    transition: 'all 0.15s',
                  }}
                >
                  {item.label}
                </button>
              );
            })}

            <button
              onClick={handleLogout}
              style={{
                width: '100%',
                textAlign: 'left',
                background: 'none',
                border: 'none',
                borderLeft: '3px solid transparent',
                padding: '12px 16px',
                fontSize: 12,
                fontFamily: 'var(--font-body)',
                cursor: 'pointer',
                color: '#777',
                letterSpacing: '0.04em',
                transition: 'all 0.15s',
              }}
            >
              Log out
            </button>
          </nav>
        </aside>

        <main className="admin-main" style={{ background: 'var(--color-bg)', padding: 28, overflowY: 'auto' }}>
          {title && (
            <h1 style={{
              fontFamily: 'var(--font-display)',
              fontSize: '28px',
              fontWeight: 400,
              color: 'var(--color-text)',
              marginBottom: 24,
            }}>
              {title}
            </h1>
          )}
          {children}
        </main>

      </div>

      {/* Backdrop */}
      {menuOpen && (
        <div
          className="admin-backdrop"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </>
  );
}